/** @graphql cc **/

import gql from 'graphql-tag';

export const HomeRecentUserPreferencesQuery = gql`
	query HomeRecentUserPreferencesQuery {
		userPreferences {
			recentFilter
		}
	}
`;

export const HomeRecentUserPreferencesMutation = gql`
	mutation HomeRecentUserPreferencesMutation($filter: RecentFilter) {
		updateUserPreferences(userPreferences: { recentFilter: $filter }) {
			recentFilter
		}
	}
`;

export const HomeRecentActivitiesQuery = gql`
	query HomeRecentActivitiesQuery(
		$cloudId: ID!
		$first: Int
		$after: String
		$eventTypes: [ActivityEventType!]
		$objectTypes: [ActivitiesObjectType!]
	) {
		activities {
			myActivities {
				all(
					filters: [
						{
							type: AND
							arguments: {
								products: [CONFLUENCE]
								objectTypes: $objectTypes
								cloudIds: [$cloudId]
								eventTypes: $eventTypes
							}
						}
					]
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							timestamp
							object {
								id
								events {
									eventType
								}
								content {
									id
									title
									type
									subType
									links {
										webui
										editui
									}
									excerpt(length: 372)
									metadata {
										currentuser {
											favourited {
												isFavourite
											}
										}
										comments {
											commentsCount
										}
									}
									space {
										alias
										id
										key
										name
									}
									likes {
										count
									}
									status
									blank
									editorVersion: properties(key: "editor") {
										nodes {
											id
											key
											value
										}
									}
									emoji: properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
										nodes {
											id
											value
											key
										}
									}
								}
							}
						}
					}
					pageInfo {
						hasNextPage
					}
				}
			}
		}
	}
`;

export const HomeRecentCreatedQuery = gql`
	query HomeRecentCreatedQuery($cql: String!, $cqlcontext: String!, $first: Int, $after: String) {
		search: confluence_search(cql: $cql, cqlcontext: $cqlcontext, first: $first, after: $after) {
			nodes {
				content {
					id
					title
					type
					subType
					links {
						webui
						editui
					}
					excerpt(length: 372)
					metadata {
						currentuser {
							favourited {
								isFavourite
							}
						}
						comments {
							commentsCount
						}
					}
					space {
						alias
						id
						key
						name
					}
					likes {
						count
					}
					status
					blank
					metadata {
						createdDate
					}
					editorVersion: properties(key: "editor") {
						nodes {
							id
							key
							value
						}
					}
					emoji: properties(keys: ["emoji-title-published"]) {
						nodes {
							id
							value
							key
						}
					}
					history {
						createdBy {
							... on KnownUser {
								accountId
							}
						}
					}
					version {
						by {
							... on KnownUser {
								accountId
							}
						}
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;
